import convertPropNames from 'src/infrastructure/caseConverter'
import { fileDownload } from 'src/infrastructure/fileDownload'
import { parseFailedResponse, parseGoodResponse } from 'src/infrastructure/parse-axios-response'
import { formatDateIso } from 'src/utils/formatDate'
import http, { Response } from '../../infrastructure/http'
import {
  Adjustment,
  ErrorTypes,
  InvalidStructureDetails,
  PendingAdjustment,
  AdjustmentDetails,
  DecisionEnum,
  AdjustmentsFilters,
} from './StockAdjustmentInBatchTypes'

const postAdjustmentFile = async (file: File) => {
  const formData = new FormData()
  formData.append('selectedFile', file)

  try {
    const result = await http.post(
      '/v2/adjustment/by-excel',
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    )
    return parseGoodResponse<Adjustment>(result.data)
  } catch (err: any) {
    if (err?.response?.data?.type === 'INVALID_STRUCTURE') {
      return parseFailedResponse<ErrorTypes.INVALID_STRUCTURE, InvalidStructureDetails>(
        ErrorTypes.INVALID_STRUCTURE,
        err?.response.data.details,
      )
    }

    throw err
  }
}

const getAdjustmentCsvFile = async (adjustmentId: number) => {
  const response = await http.get(
    `/v2/adjustment/${adjustmentId}/csv-result`,
    {
      responseType: 'blob',
    },
  )

  const fileName = response.headers['file-name'] || 'result.csv'

  fileDownload(response.data, fileName)
}

const getPendingAdjustments = async ({
  startDate,
  endDate,
  user,
}: AdjustmentsFilters) => {
  const result = await http.get(
    '/v2/adjustment/pending-adjustments', {
      params: {
        start_date: formatDateIso(startDate),
        end_date: formatDateIso(endDate),
        user: user || undefined,
      },
    },
  )

  return convertPropNames<Response<PendingAdjustment[]>>(result.data)
}

const getAdjustmentDetails = async (adjustmentId: number) => {
  const response = await http.get('/v2/adjustment/details', {
    params: {
      adjustment_id: adjustmentId,
    },
  })
  return convertPropNames<Response<AdjustmentDetails>>(response.data)
}

const confirmAdjustmentDetails = async (adjustmentId: number, decision: DecisionEnum) => {
  const response = await http.post('/v2/adjustment/confirm', {
    adjustment_id: adjustmentId, decision,
  })
  return convertPropNames<Response<any>>(response.data)
}

const cancelAdjustmentDetails = async (adjustmentId: number) => {
  const response = await http.post('/v2/adjustment/cancel', {
    adjustment_id: adjustmentId,
  })
  return convertPropNames<Response<any>>(response.data)
}

export default {
  postAdjustmentFile,
  getAdjustmentCsvFile,
  getPendingAdjustments,
  getAdjustmentDetails,
  confirmAdjustmentDetails,
  cancelAdjustmentDetails,
}
